import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ErrorHandlerService } from 'src/app/services/error-handler.service';
import { AuthService } from 'src/app/services/auth.service';
import { ProductService } from 'src/app/services/product.service';
import { MessageService, ConfirmationService } from 'primeng/api';
import { Capacitor } from '@capacitor/core';

@Component({
  selector: 'app-shopify-auth',
  templateUrl: './shopify-auth.component.html',
  styleUrls: ['./shopify-auth.component.scss'],
  providers: [ConfirmationService]
})
export class ShopifyAuthComponent implements OnInit {
  loading = true;
  errorMessage = '';
  private shop = '';
  private code = '';
  private selectedStoreId = '';

  constructor(
    private route: ActivatedRoute,
    private errorHandler: ErrorHandlerService,
    private router: Router,
    private confirmationService: ConfirmationService,
    private messageService: MessageService,
    private authService: AuthService,
    private productService: ProductService,
  ) {}

  private ensureStorageFromOpener(): Promise<void> {
    return new Promise((resolve) => {
      try {
        const ch = new BroadcastChannel('oauth-storage');
        const timeout = setTimeout(() => { ch.close(); resolve(); }, 1200);
        ch.onmessage = (e) => {
          if (e.data?.type === 'storage-dump') {
            const p = e.data.payload || {};
            for (const k of Object.keys(p)) {
              if (p[k] != null) localStorage.setItem(k, String(p[k]));
            }
            clearTimeout(timeout);
            ch.close();
            resolve();
          }
        };
        ch.postMessage({ type: 'request-storage' });
      } catch { resolve(); }
    });
  }

  ngOnInit(): void {
    this.route.queryParams.subscribe(async params => {
      await this.ensureStorageFromOpener();

      this.shop = params['shop'] || '';
      this.code = params['code'] || '';
      const state = params['state'];

      if (state) {
        try {
          const stateObj = JSON.parse(atob(state));
          this.selectedStoreId = stateObj.selectedStoreId || '';
          if (this.selectedStoreId) localStorage.setItem('ss_SelectedStoreId', this.selectedStoreId);
          if (stateObj.accessToken) localStorage.setItem('access_token', stateObj.accessToken);
        } catch {}
      }

      if (!this.selectedStoreId) {
        this.selectedStoreId = localStorage.getItem('ss_SelectedStoreId') || '';
      }

      if (this.shop && this.code && this.selectedStoreId) {
        localStorage.setItem('oauth', JSON.stringify({
          shop: this.shop,
          code: this.code,
          hmac: params['hmac'],
          host: params['host']
        }));
        this.processAuthorization();
      } else {
        this.showError('Parâmetros ausentes para integração Shopify.');
      }
    });
  }

  private processAuthorization(): void {
    const storeId = Number(this.selectedStoreId);
    this.productService.authCallback(storeId, this.shop, this.code).subscribe({
      next: (response: any) => {
        if (response.access_token) {
          this.saveAccessToken(response.access_token);
        } else {
          this.showError('Não foi possível obter o token de acesso.');
        }
      },
      error: (error) => {
        if (error.error?.error === 'duplicate_integration') {
          this.loading = false;
          this.errorMessage = 'A loja selecionada já está associada a outra conta.';
          this.confirmationService.confirm({
            message: 'A loja selecionada já está associada a outra conta.',
            icon: 'pi pi-exclamation-triangle',
            acceptLabel: 'Saiba mais',
            rejectLabel: 'Voltar',
            accept: () => window.open('https://helpcenterslicksell.tawk.help/article/integra%C3%A7%C3%A3o-com-shopify', '_blank'),
            reject: () => this.router.navigate(['/apps']),
          });
          return;
        }
        this.showError('Erro na autenticação Shopify.');
      },
    });
  }

  private saveAccessToken(accessToken: string): void {
    const payload = {
      access_token: accessToken,
      form_value: { domain: this.shop },
    };

    this.productService.createAppsStore2('shopify', payload).subscribe({
      next: () => {
        this.loading = false;
        localStorage.removeItem('oauth');

        // const isAndroid = /android/i.test(navigator.userAgent);
        // if (isAndroid) {
        //   window.location.href = 'myslick://auth/shopify?result=success&shop=' + encodeURIComponent(this.shop);
        //   return;
        // }

        if (window.opener) {
          try {
            const channel = new BroadcastChannel('oauth-channel');
            channel.postMessage({ type: 'shopify-connected' });
            channel.close();
          } catch {}
          try { window.close(); } catch {}
          return;
        }

        this.router.navigate(['/apps'], {
          queryParams: { integration: 'shopify', result: 'success' }
        });
      },
      error: () => {
        this.showError('Não foi possível salvar integração.');
      },
    });
  }

  private showError(msg: string) {
    this.loading = false;
    this.errorMessage = msg;
    this.messageService.add({ severity: 'error', summary: 'Erro', detail: msg });
    setTimeout(() => this.router.navigate(['/apps']), 3000);
  }
}
